<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <br>
      <div class="d-flex justify-end">
        <v-btn
          color="#FFFFFF"
          outlined
          class="next-style"
          elevation="0"
          @click="showFilterDialog = true"
        >
          Filter
        </v-btn>&nbsp;&nbsp;
        <v-btn
          dark
          fab
          outlined
          icon
          color="#37474F"
          small
          @click="clearFilter()"
        >
          <v-icon
            small
            dark
          >
            mdi-filter-off
          </v-icon>
        </v-btn>
      </div>
      <div v-if="PendingJobsAvailable">
        <v-card
          v-for="(item, index) in pendingJobs"
          :key="index"
          color="#FFF"
          dark
          class="card-style"
          elevation="0"
        >
          <v-card-text>
            <p class="title-text-style">
              <font class="subheader-style">
                {{ item.job.name }}
              </font>
            </p>
            <span>   <font class="key_style">{{ item.project.name }}</font></span>
              <hr class="my-2" />
            <p class="assigner_style mt-2">
              <font class="key_style">
                Assigner:
              </font>
              <font>
                {{ item.sent_by.first_name }} {{ item.sent_by.last_name }}
              </font>
            </p>
            <p
              v-if="!workerCheck"
              class="assigner_style"
            >
              <font class="key_style">
                Assigned To:
              </font>
              <font class="assigner_style">
                {{ item.sent_to.first_name }} {{ item.sent_to.last_name }}
              </font>
            </p>
            <p
              v-if="isSiteManager"
              class="assigner_style"
            >
              <font class="key_style">
                Amount:
              </font>
              <font
                v-if="item.job.amount !== null"
                style="color: green; font-weight: bold"
              >
                $ {{ item.job.amount }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p>
              <font class="key_style">
                Planned Start Date:
              </font>
              <font class="assigner_style">
                {{ item.planned_date | convertToLocal }}
              </font>
            </p>
            <span
              v-if="
                appUserOrganization.app_user_organization_id ===
                  item.job.assigned_to_id
              "
            >
              <div
                v-if="
                  (item.proposed_date === null) & (item.status === 'pending')
                "
                class="text-right mt-6"
              >
                <v-btn
                  class="accept-style"
                  elevation="0"
                  color="#64CA7F"
                  @click="showAcceptModal(item)"
                >
                  Accept </v-btn>&nbsp;&nbsp;
                <v-btn
                  class="suggest-style"
                  elevation="0"
                  color="#8abceb"
                  @click="showSuggestDateModal(item)"
                >
                  Suggest new date
                </v-btn>
              </div>
              <div
                v-else
                class="text-right"
              >
                <v-chip
                  close-icon="mdi-close-outline"
                  color="orange"
                  class="mt-6"
                >
                  <v-icon
                    small
                    class="mr-1"
                    color="#101010"
                  >
                    mdi-clock-outline </v-icon>Suggested Date: {{ item.proposed_date | convertToLocal }}
                </v-chip>
              </div>
            </span>
          </v-card-text>
        </v-card>
        <div
          ref="observer"
          class="observer"
        />
        <div class="text-center">
          <v-progress-circular
            v-if="lazyLoader"
            size="25"
            :width="1"
            color="#E2E2E2"
            indeterminate
          />
        </div>
      </div>
      <div
        v-else
        class="empty-alert-div mt-5"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>No tasks found
          </p>
          <br>
          <br>
          <br>
        </v-card>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-4"
    >
      <v-card
        color="#E2E2E2"
        elevation="0"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <filter-pending-jobs
      v-if="showFilterDialog"
      @closed="showFilterDialog = false"
      @filterData="filterPendingJobs"
    />
    <accept-job-dialog
      v-if="acceptModal"
      :job-request-details="jobRequestDetails"
      @accepted="acceptedJobRequest()"
      @closed="acceptModal = false"
    />
    <suggest-job-date-dialog
      v-if="suggestDateModal"
      :job-request-details="jobRequestDetails"
      @suggested="requestedDate"
      @closed="suggestDateModal = false"
    />
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import AcceptJobDialog from './AcceptJobDialog.vue';
import SuggestJobDateDialog from './SuggestJobDateDialog.vue';
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';
import FilterPendingJobs from './FilterPendingJobs.vue';

export default {
  name: 'JobsPending',
  components: {
    'accept-job-dialog': AcceptJobDialog,
    'suggest-job-date-dialog': SuggestJobDateDialog,
    'centre-spinner': spinner,
    'filter-pending-jobs': FilterPendingJobs,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('DD-MM-YYYY hh:mm A');
    },
  },
  data: () => ({
    loading: false,
    acceptModal: false,
    suggestDateModal: false,
    lazyLoader: false,
    jobRequestDetails: null,
    showFilterDialog: false,
    startPage: 0,
    filteredData: null,
  }),
  computed: {
    appUserOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    pendingJobs () {
      return this.$store.getters['jobs/getPendingJobs'];
    },
    PendingJobsAvailable () {
      if (this.pendingJobs.length === 0) {
        return false;
      }
      return true;
    },
    anyUserOrganizationsAvailable () {
      if (this.appUserOrganizationsList.length !== 0) {
        return true;
      }
      return false;
    },
    appUserOrganizationsList () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    isSiteManager () {
      return this.appUserOrganization.app_user_role === 'site-manager';
    },
    workerCheck () {
      if (this.appUserOrganization.app_user_role === 'worker') {
        return false;
      }
      return false;
    },
    siteManagerCheck () {
      if (this.appUserOrganization.app_user_role === 'site-manager') {
        return true;
      }
      return false;
    },
    jobFilters () {
      return this.$store.getters['jobs/getJobFilters'];
    },
  },
  async mounted () {
    this.loading = true;
    await this.$store.dispatch('jobs/clearAppUserPendingJobs');
    this.anyUserOrganizationsAvailable && (await this.getPendingJobs());
    this.checkStoreFilter();
    await this.loadMore();
    this.loading = false;
  },
  methods: {
    checkStatus (status) {
      if (status === null) {
        return true;
      }
      return false;
    },
    async checkStoreFilter () {
      if (Object.keys(this.jobFilters).length !== 0) {
        this.filteredData = this.jobFilters;
      } else {
        this.filteredData = null;
      }
    },
    showAcceptModal (item) {
      this.jobRequestDetails = item;
      this.acceptModal = true;
    },
    showSuggestDateModal (item) {
      this.jobRequestDetails = item;
      this.suggestDateModal = true;
    },
    async filterPendingJobs (data) {
      this.loading = true;
      this.startPage = 0;
      this.filteredData = data;
      await this.$store.dispatch('jobs/clearAppUserPendingJobs');
      await this.getPendingJobs();
      this.loading = false;
    },
    async getPendingJobs () {
      if (this.workerCheck) {
        return;
      }
      this.lazyLoader = true;
      await this.$store
        .dispatch('jobs/fetchPendingJobs', {
          externalId: this.appUserOrganization.organization.external_id,
          params: {
            params: {
              projectId:
                this.filteredData !== null
                  ? this.filteredData.project !== ''
                    ? this.filteredData.project
                    : null
                  : null,
              startPage: this.startPage,
              limit: 5,
              status: 'pending',
            },
          },
        })
        .then(() => {
          this.startPage += 5;
          this.lazyLoader = false;
        });
    },
        async clearFilter () {
      this.loading = true;
      this.startPage = 0;
      this.filteredData = null;
          await this.$store.dispatch('jobs/clearAppUserPendingJobs');
      this.$store.dispatch('jobs/storeJobFilters', {});
      await this.getPendingJobs(this.statusId);
      this.loading = false;
    },
    async acceptedJobRequest () {
      this.loading = true;
      await this.$store
        .dispatch('jobs/acceptedJobRequest', {
          jobRequestId: this.jobRequestDetails.id,
          data: {
            proposed_date: this.jobRequestDetails.planned_date,
            status: 'accepted',
          },
        })
        .then((Response) => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Accepted Job Request.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.startPage = 0;
          this.$store.dispatch('jobs/clearAppUserPendingJobs');
          this.getPendingJobs();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async requestedDate (date) {
      this.loading = true;
      await this.$store.dispatch('jobs/requestedDate', {
        jobRequestId: this.jobRequestDetails.id,
        data: {
          proposed_date: date,
          status: 'pending',
        },
      });
      this.startPage = 0;
      await this.$store.dispatch('jobs/clearAppUserPendingJobs');
      await this.getPendingJobs();
      this.loading = false;
    },
    async loadMore () {
      if (this.pendingJobs.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.getPendingJobs();
      }
    },
  },
};
</script>

<style scoped>
.card-style {
  border-radius: 10px;
  margin-top: 20px;
}

.observer {
  height: 80px;
}

.rounded {
  border-radius: 10px !important;
}

.accept-style,
.suggest-style {
  height: 30px !important;
  font-size: 12px;
  padding: 0px 15px !important;
  font-weight: lighter !important;
  text-transform: none !important;
}

.time-style .value-text-style {
  font-size: 12px;
}

.time-style {
  display: flex;
  flex-direction: column;
  padding-top: 6px;
}

.col {
  padding: 0px;
}

.empty-alert-msg {
  padding: 12px;
}
p {
  margin-bottom: 0px;
}
.assigner_style {
  font-size: 13px;
  border: 1px #ccc;
}
.subheader-style {
  text-transform: capitalize;
}
.key_style {
  font-size: 13px;
  font-weight: bold;
}
hr {
  border-color: #706d6d1a!important;
}
.next-style {
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}
</style>
